import { combineReducers, createReducer } from "@reduxjs/toolkit";
import { housingsReducer } from "./housingsReducer.ts";
import { userReducer } from "./userReducer.ts";
import { adminReducer } from "./Admin/adminReducer";
import { contractAssignmentReducer } from "./ContractAssignment/reducer";
import {AISearchReducer} from "./AISearch/reducer";

export const commonReducer = combineReducers({
  housingsReducer,
  userReducer,
  adminReducer,
  contractAssignmentReducer,
  AISearchReducer,
});
